var exports = {
  "k": "x112a1f60--ad384e--container",
  "K": "x112a1f60--ad384e--icon",
};

module.exports = exports;
